import { render, staticRenderFns } from "./L03ObjectLiterals.vue?vue&type=template&id=cb220650&"
import script from "./L03ObjectLiterals.vue?vue&type=script&lang=js&"
export * from "./L03ObjectLiterals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports